module.exports = __webpack_public_path__ + "img/topImg.d8d32f22.png";